function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function getStorage(_ref) {
  var errorMessage = _ref.errorMessage;
  return {
    getItem: function getItem() {
      console.warn(errorMessage);
      return null;
    },
    setItem: function setItem() {
      console.warn(errorMessage);
    },
    removeItem: function removeItem() {
      console.warn(errorMessage);
    },
    clear: function clear() {
      console.warn(errorMessage);
    },

    get length() {
      console.warn(errorMessage);
      return 0;
    }

  };
}

var InMemoryStorage =
/*#__PURE__*/
function () {
  function InMemoryStorage() {
    this._data = {};
    this.length = 0;
  }

  var _proto = InMemoryStorage.prototype;

  _proto.getItem = function getItem(key) {
    if (key in this._data) {
      return this._data[key];
    }

    return null;
  };

  _proto.setItem = function setItem(key, value) {
    this._data[key] = value;
    this.length = Object.keys(this._data).length;
  };

  _proto.removeItem = function removeItem(key) {
    if (key in this._data) {
      delete this._data[key];
    }

    this.length = Object.keys(this._data).length;
    return null;
  };

  _proto.key = function key(index) {
    if (index === undefined) {
      throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present.");
    }

    var key = Object.keys(this._data)[index];

    if (key !== undefined) {
      return key;
    }

    return null;
  };

  _proto.clear = function clear() {
    this._data = {};
    this.length = 0;
  };

  return InMemoryStorage;
}();

var InMemoryStorage$1 = new InMemoryStorage();

var storageTypes = {
  sessionStorage: 'sessionStorage',
  localStorage: 'localStorage'
};
var storagesList = Object.values(storageTypes).join(', ');
function validateStorageType(storageType) {
  if (!storageType) {
    throw new Error("Please provide one of storages: " + storagesList);
  }

  if (!Object.values(storageTypes).includes(storageType)) {
    throw new Error("\"" + storageType + "\" is not supported. use one of these storages: " + storagesList);
  }
}
function getErrorMessage(storageType) {
  return "Looks like you've disabled \"" + storageType + "\". Enable it to avoid this warning.";
}

var SafeStorage =
/*#__PURE__*/
function () {
  SafeStorage.isNativeStorageSupported = function isNativeStorageSupported(storageType) {
    validateStorageType(storageType);
    var TEST_VALUE = 'test_value';

    try {
      var key = 'safe-web-storage.support';
      window[storageType].setItem(key, TEST_VALUE);
      var value = window[storageType].getItem(key);
      window[storageType].removeItem(key);
      return value === TEST_VALUE;
    } catch (e) {
      return false;
    }
  };

  function SafeStorage(storageType, options) {
    validateStorageType(storageType);
    this._storageType = storageType;
    this._options = _extends({
      errorMessage: getErrorMessage(storageType)
    }, options);
    var isSessionStorage = storageType === storageTypes.sessionStorage;

    if (!SafeStorage.isNativeStorageSupported(storageType)) {
      this._storage = isSessionStorage ? InMemoryStorage$1 : getStorage(this._options);
      this._isInMemoryStorageUsed = isSessionStorage;
      this._isNativeStorageUsed = false;
      console.warn(this._options.errorMessage);
      return;
    }

    this._storage = window[storageType];
    this._isNativeStorageUsed = true;
    this._isInMemoryStorageUsed = false;
  }

  var _proto = SafeStorage.prototype;

  _proto.getItem = function getItem(key) {
    return this._storage.getItem(key);
  };

  _proto.setItem = function setItem(key, value) {
    return this._storage.setItem(key, value);
  };

  _proto.removeItem = function removeItem(key) {
    return this._storage.removeItem(key);
  };

  _proto.key = function key(index) {
    return this._storage.key(index);
  };

  _proto.clear = function clear() {
    return this._storage.clear();
  };

  _createClass(SafeStorage, [{
    key: "isNativeStorageUsed",
    get: function get() {
      return this._isNativeStorageUsed;
    }
  }, {
    key: "isInMemoryStorageUsed",
    get: function get() {
      return Boolean(this._isInMemoryStorageUsed);
    }
  }, {
    key: "length",
    get: function get() {
      return this._storage.length;
    }
  }]);

  return SafeStorage;
}();

function createSafeLocalStorage(options) {
  return new SafeStorage(storageTypes.localStorage, options);
}

function createSafeSessionStorage(options) {
  return new SafeStorage(storageTypes.sessionStorage, options);
}

export { createSafeLocalStorage, createSafeSessionStorage };
